import templateScorecardExport from '../../../../../../Template/config/components/scorecard/ScorecardView/ScorecardExport';
export default {
  ...templateScorecardExport,
  columnWidths: {
    metricsLabels: 35,
    norm: 10,
    metrics: 15
  },
  defaultAlignment: 'center',
  defaultRowHeight: 15,
  defaultFontSize: 10,
  styles: {
    h0: {
      type: 'header',
      height: 15,
      format: {
        fill: '#eeeeee',
        color: '#002C59',
        font: {
          name: 'Arial',
          size: 12,
          bold: true
        }
      }
    },
    h1: {
      type: 'header',
      height: 15,
      format: {
        fill: '#eeeeee',
        color: '#002C59',
        font: {
          name: 'Arial',
          size: 12,
          bold: true
        }
      }
    },
    hb0: {
      type: 'header',
      height: 15,
      format: {
        norm: true,
        fill: '#757575',
        color: '#ffffff',
        font: {
          name: 'Arial',
          size: 12,
          bold: true
        }
      }
    },
    d0i: {
      type: 'metric',
      height: 15,
      format: {
        border: {
          style: 'thin',
          color: '#eeeeee'
        }
      },
      font: {
        name: 'Arial',
        italic: true
      }
    },
    demphasized: {
      type: 'metric',
      height: 15,
      font: {
        name: 'Arial'
      }
    },
    dh0: {
      type: 'metric',
      height: 15,
      font: {
        name: 'Arial'
      },
      format: {
        fill: '#eeeeee'
      }
    },
    d0: {
      type: 'metric',
      height: 15,
      format: {
        border: {
          style: 'thin',
          color: '#eeeeee'
        }
      },
      font: {
        name: 'Arial'
      }
    },
    d1: {
      type: 'metric',
      height: 15,
      offset: '        ',
      format: {
        border: {
          style: 'thin',
          color: '#eeeeee'
        }
      },
      font: {
        name: 'Arial'
      }
    },
    eol: {
      type: 'header',
      height: 20
    }

  },

  sheetHeaders: [
    {
      field: 'brand',
      metricsLabel: 'Brand',
      alignment: 'center',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'thumbnail',
      rowHeight: 50,
      normLabel: 'NORM',
      alignment: 'center',
      font: {
        name: 'Arial',
        bold: true,
        size: 12
      }
    },
    {
      field: 'ad_code',
      rowHeight: 25,
      metricsLabel: 'Ad Code',
      alignment: 'center',
      font: {
        name: 'Arial',
        bold: true,
        size: 12
      }
    },
    {
      field: 'title',
      metricsLabel: 'Title',
      alignment: 'center',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'last_month_tested',
      metricsLabel: 'Last Month Tested',
      alignment: 'center',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'length',
      metricsLabel: 'Ad Length',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'first_air_date',
      metricsLabel: 'Launch Date',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'spend_ltd',
      metricsLabel: 'LTD Spend (000s)',
      format: '"$"#,##',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'impressions',
      metricsLabel: 'LTD Impressions',
      format: '#,##',
      font: {
        name: 'Arial'
      }
    },
    {
      field: 'n',
      metricsLabel: 'Sample Size',
      includeInNorm: true,
      format: '#,0',
      font: {
        name: 'Arial'
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/components/scorecard/ScorecardView/ScorecardExport/index.js